import React, { ComponentPropsWithoutRef } from 'react';
import { cn } from '@zep/utils';
interface Props extends ComponentPropsWithoutRef<'label'> {
  highlighted?: boolean;
  disabled?: boolean;
}
export const PlanRadioLabel = (props: Props) => {
  const {
    children,
    className,
    highlighted = false,
    disabled,
    ...rest
  } = props;
  return <label {...rest} className={cn('flex h-[80px] w-full cursor-pointer items-center space-x-2 rounded-[10px] border border-gray-200 pl-[20px] pr-[24px]', highlighted ? 'bg-primaryBg shadow-[0_1px_4px_0_rgba(42,39,65,0.08)] border !border-primary' : !disabled ? 'hover:bg-gray-50' : undefined, className)} data-sentry-component="PlanRadioLabel" data-sentry-source-file="PlanRadioLabel.tsx">
      {children}
    </label>;
};